import BasicAuthForm from "./BasicAuth";

export default BasicAuthForm;
